import React from 'react';
import './ModernFooter.css';

const ModernFooter = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <p className="footer-text">
            Built by Cliff
          </p>
          <p className="footer-copyright">
            © {new Date().getFullYear()} COVA Learning Resources
          </p>
        </div>
      </div>
    </footer>
  );
};

export default ModernFooter;
